import React from 'react';
import PropTypes from 'prop-types';
import { range } from 'lodash';
import getTime, { getPeriod } from '../../utils/periodTime';

import Form from '../Form';
import DateInput from '../DateInput';
import { CalendarIconWrapper } from '../DateInput/DateInput.style';
import { DateRangeColumns, DateColumnsRow, SelectDateWrapper, SelectDate, SearchBtn } from './DateRangeForm.styles';
import { ExportToCsvButton } from 'src/components/Buttons/ExportToCsvButton/ExportToCsvButton.style';
import { ExportIcon } from 'src/assets/icons/ExportIcon';
import { getTranslationFor } from 'src/locale/lang';

class DateRangeForm extends Form {
    static fieldsValidation = {
        startDate: [ 'required', 'date' ],
        endDate: [ 'required', 'date' ]
    };

    static defaultProps = Object.assign({
        markValid: false
    }, Form.defaultProps);

    UNSAFE_componentWillReceiveProps(props) {
        this.setState({
            data: props.data
        });
    }

    onSubmit(e) {
        e.preventDefault();

        Form.prototype.onSubmit.call(this, e);
    }

    changeTime(e) {
        const time = e.target.value;

        if (!time) {
            return;
        }

        this.state.data = getTime(time);

        this.setState({
            data: this.state.data
        });

        return this.isValid();
    }

    renderForm() {
        const { startDate, endDate } = this.state.data;

        let maxDate;
        if (endDate) {
            const now = new Date();
            const end = new Date(endDate);
            maxDate = end > now ? now : end;
        }

        const time = getPeriod(startDate, endDate);

        return (
            <DateColumnsRow>
                <DateRangeColumns>
                    {
                        this.getField(
                            <DateInput
                                label={ getTranslationFor('DATE_RANGE_FROM_LABEL') }
                                maxDate={ maxDate }
                                { ...this.getFieldParameters('startDate') }
                            />
                        )
                    }
                </DateRangeColumns>

                <DateRangeColumns>
                    {
                        this.getField(
                            <DateInput
                                label={ getTranslationFor('DATE_RANGE_TO_LABEL') }
                                minDate={ startDate ? new Date(startDate) : undefined }
                                maxDate={ new Date() }
                                { ...this.getFieldParameters('endDate') }
                            />
                        )
                    }
                </DateRangeColumns>

                <DateRangeColumns>
                    <CalendarIconWrapper />
                    <SelectDateWrapper>
                        Choose a date range
                        <SelectDate value={ time } onChange={ this.changeTime.bind(this)}>
                            <option value='custom' style={ { display: 'none' } }>Custom date</option>
                            <option value='today'>Today</option>
                            <option value='3-days'>Last 3 days</option>
                            <option value='7-days'>Last 7 days</option>
                            <option value='week'>This week</option>
                            <option value='month'>This month</option>
                        </SelectDate>
                    </SelectDateWrapper>
                </DateRangeColumns>

                <DateRangeColumns>
                    <SearchBtn type='submit' onClick={this.props.handleOnSubmit}>
                        {getTranslationFor('DATE_RANGE_NEXT_BUTTON')}
                    </SearchBtn>
                </DateRangeColumns>


                <ExportToCsvButton type='button' onClick={ this.props.onGenerateCSV } isDisabled={this.props.isDisabled}>
                    <ExportIcon />
                    Export to CSV
                </ExportToCsvButton>


            </DateColumnsRow>

        );
    }
}

export default DateRangeForm;
